import React, { Component } from 'react';
import HomePage from './homepage/home';
import './App.css';
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga';
import {
  Router,
  Route,
  Switch
} from 'react-router-dom';

import People from './people/people';
import Author from './profile/author';
import Verify from './login/verify';
import Success from './login/success';
import EditWork from './yourwork/editwork'
import PeopleWiki from './people/people-wiki';
import Article from './article/article';
import Books from './books/books';
import Feedback from './feedback/feedback';
import ContactUs from './contact/contact';
import News from './news/news';
import NewsOpen from './news/newsopen';
import InstituteDesc from './institution_new/institute_desc';
import Periodicals from './periodicals/periodicals';
import Glossary from './glossary/glossary';
import Search from './search/search';
import Faculty from './faculty/faculty';
import FacultyWiki from './faculty/faculty_wiki';
import Events from './events/events';
import EventOpen from './events/eventOpen';
import UpcomingOpen from './events/upcomingOpen';
import ResearchDivision from './research/researchDivision';
import About from './about/about';
import ResearchCluster from './research/researchCluster';
import YourWork from './yourwork/yourwork';
import Banking from './banking/banking';
import Login from './login/login';
import Forgot_pwd from './login/forgot_pwd';
import submitted_work_details from './yourwork/submitted_work_listing';
import submitted_more from './yourwork/submitted_more';
import Error404 from './error/404';
import Error403 from './error/403';
import './index.css'
import Thesis from './thesis/thesis';
import bookChapters from './book chapters/bookchapters';
import conference from './conference/conference';
import reference from './reference/reference';
import Project from './research/projects';
import Archive from './events/archive';
import InstitutionNew from './institution_new/institutions';
import InstitutionMore from './institution_new/institution_more';
import Academic from './institution_new/academy';
import Taxonomy from './taxonomy.js/taxonomy';
import Content from './content/content';
import PeriodDesc from './periodicals/period_desc';
import HomeNew from './homepage/homenew';
import Research from './research/researchnew';
import academyOpen from './institution_new/academyOpen';
import ResearchCenters from './misc/researchCenters';
import Programs from './misc/programs';
import ClusterPopup from './research/clusterpopup';
import ClusterDesc from './research/clusterDescription';
import ClusterDetails from './research/clusterDetails';
import Economics from './specialized_database/economics';
import Bioethics from './specialized_database/bioethics';
import Database from './specialized_database/sira';
import Convenants from './specialized_database/covenants';
import Sira from './specialized_database/sira';
import Papers from './papers/papers';
import White from './papers/whitepapers';
import Report from './report/report'
import Lamha from './lamha/lamha'
import Astrolable from './astrolable/astrolable'
import Ongoing from './projects/ongoing-projects'
import Innerbook from './books/innerbook'
import Profile from './profile/profile'
import Claim from './profile/claim';
import Approve from './yourwork/approvereject';
import ProjectAll from './project/project';
import ProjectDetails from './projectDetails/projectDetails';
import Clusters from './research/clusters';
import ClustersGrants from './research/clusterGrants';
import CisFaculty from './cis/faculty';
import Podcast from './podcast/podcast'
import Episodes from './podcast/episode'
import PodDetails from './podcast/podDetails'
import NewFaculty from './faculty/newFaculty';
import NewHome from './homepage/newHome';
import FacultyDetails from './faculty/facultydetails';
// import newCluster from './research/newCluster';
import clusterA from './research/clusterA';
import NewContact from './contact/newContact';
import ResearchCenter from './research/researchCenter';
import ThesisOpen from './thesis/thesisOpen';
import Grants from './grants/grants';

const history = createHistory()
ReactGA.initialize('UA-139161970-1');
history.listen((location, action) => {
  ReactGA.pageview(location.pathname);
  console.log(location.pathname)
});

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route path="/" component={NewHome} exact />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Login} />
          <Route path="/verify" component={Verify} />
          <Route path="/success" component={Success} />
          {/* <Route path="/nhome" component={NewHome} /> */}
          <Route path="/password" component={Forgot_pwd} exact />
          <Route path="/biographies" component={People} exact />
          <Route path="/biographies/search/:key" component={People} exact />
          <Route path="/biographies/:nid" component={PeopleWiki} />
          <Route path="/articles" component={Article} exact />
          <Route path="/feedback" component={Feedback} exact />
          <Route path="/submit_your_work" component={YourWork} exact />
          <Route path="/submit_your_work/:stage" component={YourWork} exact />
          <Route path="/edit_your_work/:id" component={EditWork} exact />
          {/* <Route path="/publication/:nid/:anchor" component={submitted_work_details} /> */}
          <Route path="/theses_desc/:nid/:anchor" component={submitted_work_details} />
          <Route path="/article_desc/:nid/:anchor" component={submitted_work_details} />
          <Route path="/book_desc/:nid/:anchor" component={submitted_work_details} />
          <Route path="/book_chap_desc/:nid/:anchor" component={submitted_work_details} exact />
          <Route path="/conf_desc/:nid/:anchor" component={submitted_work_details} exact />
          <Route path="/publication/:nid" component={submitted_work_details} />
          <Route path="/publication/:title/:nid" component={submitted_work_details} />
          <Route path="/theses_desc/:nid" component={submitted_work_details} />
          <Route path="/article_desc/:nid" component={submitted_work_details} />
          <Route path="/book_desc/:nid" component={submitted_work_details} />
          <Route path="/book_chap_desc/:nid" component={submitted_work_details} exact />
          <Route path="/conf_desc/:nid" component={submitted_work_details} exact />
          <Route path="/reference/:id" component={reference} exact />
          {/* <Route path="/cis_publication" component={Submitted_Work} exact/> */}
          <Route path="/cis_publication" component={Books} exact />
          <Route path="/theses" component={Thesis} exact />
          <Route path="/theses/:nid" component={ThesisOpen} exact />
          <Route path="/book_chap" component={bookChapters} exact />
          <Route path="/conferences" component={conference} exact />
          <Route path="/submitted_work/:id" component={submitted_more} exact />
          <Route path="/contact-us" component={NewContact} exact />
          <Route path="/news" component={News} />
          <Route path="/news_desc" component={NewsOpen} />
          <Route path="/academic_institution" component={Academic} exact />
          <Route path="/academic_institution/page/:page" component={Academic} exact />
          <Route path="/academic_institution/page/:page/:key" component={Academic} exact />

          <Route path="/academic_institution/:nid" component={academyOpen} exact />
          <Route path="/financial_institution" component={InstitutionNew} exact />
          <Route path="/financial_institution/:sec/:page" component={InstitutionNew} exact />
          {/* <Route path="/financial_institution/:id" component={InstitutionMore} exact /> */}
          <Route path="/financial_institution/:type/desc/:nid" component={InstituteDesc} exact />
          {/* <Route path="/periodicals" component={Periodicals} exact /> */}
          <Route path="/periodicals_desc/:nid" component={PeriodDesc} />
          <Route path="/glossary" component={Glossary} exact />
          <Route path="/glossary/:key" component={Glossary} exact />
          <Route path="/search" component={Search} exact />
          <Route path="/search/:id" component={Search} exact />
          <Route path="/search/:id/:page" component={Search} exact />
          <Route path="/faculty" component={NewFaculty} exact />
          <Route path="/research/faculty/section/:section/:filter" component={NewFaculty} exact />
          <Route path="/research/faculty/section/:section/:filter/:page" component={NewFaculty} exact />
          <Route path="/faculty/section/:filter/:page" component={NewFaculty} exact />
          <Route path="/faculty/:id" component={FacultyDetails} />
          <Route path="/events" component={Events} exact />
          <Route path="/events/:id" component={Events} exact />
          <Route path="/events/:id/:page" component={Events} exact />
          <Route path="/event_desc/:title/:id" component={EventOpen} />
          <Route path="/upcoming/:title/:id" component={UpcomingOpen} />
          <Route path="/research_division" component={ResearchDivision} exact />
          <Route path="/about" component={About} exact />
          <Route path="/research-centers" component={ResearchCenters} exact />
          <Route path="/centers_details/:name" component={ResearchCenter} exact />
          <Route path="/cluster_details/:id" component={Clusters} exact />
          {/* <Route path="/cluster_details1/:id" component={Clusters} exact /> */}
          <Route path="/cluster_detail_info/:id" component={ClusterDetails} exact />
          <Route path="/cluster_detail_info/:id/:section" component={ClusterDetails} exact />
          <Route path="/cluster_descrption/:id" component={ClusterDesc} exact />
          <Route path="/programs" component={Programs} exact />
          <Route path="/research" component={Research} exact />
          <Route path="/research/faculty" component={NewFaculty} exact />
          <Route path="/research/:type" component={Research} exact />
          <Route path="/research/:type/faculty/section/:section/:filter/:page" component={Research} exact />
          <Route path="/research_cluster" component={ResearchCluster} exact />
          <Route path="/project" component={Project} exact />
          <Route path="/archive" component={Archive} exact />
          <Route path="/project/:id" component={Project} exact />
          <Route path="/banking_regulation" component={Banking} exact />
          <Route path="/periodicals" component={Periodicals} exact />
          <Route path="/periodicals/:type" component={Periodicals} exact />
          <Route path="/periodicals/:type/:page" component={Periodicals} exact />
          <Route path="/periodicals/:type/:page/:key" component={Periodicals} exact />
          <Route path="/taxonomy/:title/:id" component={Taxonomy} exact />
          <Route path="/content/:title/:type/:id" component={Content} exact />
          <Route path="/economics" component={Economics} exact />
          <Route path="/bioethics" component={Bioethics} exact />
          <Route path="/convenants" component={Convenants} exact />
          <Route path="/sira" component={Sira} exact />
          <Route path="/papers" component={Papers} exact />
          <Route path='/white' component={White} exact />
          <Route path="/report" component={Report} exact />
          <Route path="/lamha" component={Lamha} exact />
          <Route path="/astrolable" component={Astrolable} exact />
          <Route path="/ongoing" component={Ongoing} exact />
          <Route path="/specialised/:title" component={Database} exact />
          <Route path="/profile" component={Profile} />
          <Route path="/author/:id" component={Author} />
          <Route path="/claim_your_work" component={Claim} />
          <Route path="/approve_or_reject/:id/:name/:pubid" component={Approve} />
          <Route path="/cis_publication/:nid" component={Innerbook} exact />
          <Route path="/cis_publication/:title/:nid" component={Innerbook} exact />
          <Route path="/projects" component={ProjectAll} exact />
          <Route path="/projects/:stage" component={ProjectAll} exact />
          <Route path="/projects/:stage/:page" component={ProjectAll} exact />
          <Route path="/projectdetails/:nid" component={ProjectDetails} exact />
          <Route path="/cluster_grants" component={ClustersGrants} exact />
          <Route path="/cluster_grants/:stage" component={ClustersGrants} exact />
          <Route path="/podcast" component={Podcast} exact />
          <Route path="/episodes/:id" component={Episodes} exact />
          <Route path="/podcast/:id" component={PodDetails} exact />
          <Route path="/grants" component={Grants} exact />

          {/* <Route path="/clustera" component={clusterA} exact /> */}
          <Route path="/403forbidden" component={Error403} exact />
          <Route path='*' component={Error404} />
        </Switch>
      </Router>
    );
  }
}


export default App;
